import { Model } from '@vuex-orm/core'
import ProductType from "./ProductType"
import ProductCategory from "./ProductCategory";
import Product from "./Product";

export default class ProductClassification extends Model {
	static entity = 'product_classifications';

	static fields () {
		return {
			id: this.attr(null),
			product_type_id: this.attr(null),
			product_type: this.belongsTo(ProductType, 'product_type_id'),
			name: this.attr(null),
			position: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			products: this.hasMany(Product, 'product_classification_id', 'id'),
		}
	}

	static apiConfig = {
		actions: {
			fetch: {
				method: 'get',
				url: '/product-classifications',
				dataTransformer: (response) => {
					if(response.status === 200 && response.data.data.product_classifications) {
						return response.data.data.product_classifications;
					} else {
						return [];
					}
				}
			}
		}
	}

}
